import React from "react";
import FormControl from "@mui/material/FormControl";
import { FormHelperText, InputLabel, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import { map } from "ramda";
import PropTypes from "prop-types";
import { SocialLinkPlatforms } from "../cspServices";

const SocialLinkPlatformSelect = props => {
  const {
    onChange,
    value,
    error,
    helperText,
    onBlur,
    title = "Social Link Platform",
  } = props;

  return (
    <FormControl fullWidth error={error}>
      <InputLabel htmlFor="social-platform">{title}</InputLabel>
      <Select
        value={value || ""}
        onChange={onChange}
        SelectDisplayProps={{
          style: { fontSize: "1.8rem", lineHeight: "2.4rem" },
        }}
        inputProps={{
          name: "social-platform",
          id: "social-platform",
        }}
        error={error}
        onBlur={onBlur}
      >
        {map(sl => {
          return (
            <MenuItem value={sl.value} key={sl.value}>
              {sl.label}
            </MenuItem>
          );
        }, SocialLinkPlatforms)}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

SocialLinkPlatformSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SocialLinkPlatformSelect;
